/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';

const DisplayPDF = ({ url }) => {
    const [numPages, setNumPages] = useState(null);
    const [loading, setLoading] = useState(true);

    const onDocumentLoadSuccess = (docObj) => {
        setNumPages(docObj.numPages);
        setLoading(false);
      };

      const renderPages = () => {
        const pages = [];
        for (let pageNumber = 1; pageNumber <= numPages; pageNumber++) {
          pages.push(<Page key={pageNumber} pageNumber={pageNumber} renderTextLayer={false} width={1000} />);
        }
        return pages;
      };

    return (
        <div>
          <Document file={url} onLoadSuccess={onDocumentLoadSuccess}>
          {numPages && renderPages()}
          </Document>
        </div>
    );
};

export default DisplayPDF;
